import { createActionGroup, props } from '@ngrx/store';
import { ProductCode, ProductPlatformGroup } from '@mkp/shared/models';

export const ProductOfferingActions = createActionGroup({
  source: 'Product Offering Page',
  events: {
    Enter: props<{ platformGroup: ProductPlatformGroup }>(),
    'Product Selected': props<{ productCode: ProductCode }>(),
  },
});
